import React, { useRef } from "react";
import {
    intl,
    DmsAltBox,
    DmsPage,
    DmsTable,
    DmsButtonGroup,
    DmsButton,
    getToken,
} from "dmsbasereact";
import { getBaseURL } from "../../build_config";
import Swal from "sweetalert2";
import { Typography, Box } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

export const EmittedCertificatesPage = () => {
    const table = useRef(null);

    const handleDownloadCertificate = async (certificatePk) => {
        try {
            const token = getToken();
            const url = `${getBaseURL()}/certificate/${certificatePk}/download`;

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token.access_token}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Download failed: ${response.statusText}`);
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = `certificate-${certificatePk}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: intl.get("DownloadError").d("Download Error"),
                text: err.message,
            });
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
    };

    const header = [
        {
            label: intl.get("TrainingName").d("Training Name"),
            column_name: "training_name",
            filter: true,
        },
        {
            label: intl.get("UserName").d("User Name"),
            column_name: "user_name",
            filter: true,
        },
        {
            label: intl.get("IssueDate").d("Issue Date"),
            column_name: "issue_date",
            filter: true,
            control: "date",
        },
        {
            label: intl.get("Certificate").d("Certificate"),
            column_name: "certificate",
            width: "280px",
            sortable: false,
            filter: false,
            element: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {intl.get("Code").d("Code")}: {row.certificate_code}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            {intl.get("ValidUntil").d("Valid Until")}: {formatDate(row.valid_until_date)}
                        </Typography>
                    </Box>
                    <DmsButtonGroup>
                        <DmsButton
                            icon={<DownloadIcon />}
                            onClick={() => handleDownloadCertificate(row.pk)}
                            title={intl.get("DownloadCertificate").d("Download Certificate")}
                        />
                    </DmsButtonGroup>
                </Box>
            ),
        },
    ];

    return (
        <DmsPage name="EmittedCertificates">
            <DmsAltBox.Card>
                <DmsAltBox.Header>
                    <Typography variant="h3" sx={{ fontSize: "1.1rem" }}>
                        {intl.get("EmittedCertificates").d("Emitted Certificates")}
                    </Typography>
                </DmsAltBox.Header>
                <DmsAltBox.Body>
                    <DmsTable
                        header={header}
                        managed={true}
                        needs_authentication={true}
                        ref={table}
                        url="/certificate/emitted/table"
                        export_table={false}
                    />
                </DmsAltBox.Body>
            </DmsAltBox.Card>
        </DmsPage>
    );
};

export default EmittedCertificatesPage;
